module.exports = __webpack_public_path__ + "static/img/manual_ja_31.893d621.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_31.png
// module id = Mu5p
// module chunks = 4